// extracted by mini-css-extract-plugin
export default {"pageInput":"PageInput_pageInput__nrn3z","label":"PageInput_label__HV2c9","input":"PageInput_input__J+Naw"};